import React, { useState, useEffect, useRef } from 'react';
import { handleChange, handleSubmit } from "../../Controller/CreateOppurtunityController";
import OppurtunitySourceService from "../../../Setup/controller/OppurtunitySourceController/OppurtunitySourceController";
import OppurtunityStatusService from "../../../Setup/controller/OppStatusController/OppStatusController";
import OppurtunityService from "../../Controller/OppurtunityController";
import { useNavigate } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import HelpSite from "../../../Common/HelpLink";
import TaxService from "../../../Setup/controller/TaxCodesController/TaxCodeController";
import CurrencyService from "../../../Setup/controller/CurrencyController/CurrencyController";
import CountryService from "../../../Setup/controller/CountryController/CountryController";
import TitleService from "../../../Setup/controller/TitleController/TitleController";
import CustomerService from "../../../Customer/Controller/CustomerController";
import JobRoleService from "../../../Setup/controller/JobRoleController/JobRoleController";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import CommunicationService from "../../../Lead/Controller/CommunicationController";
import CreateOppCommunicationModal from './CreateOppCommunicationModal';
import CustomerSelectionModal from "./CustomerSelectionModal";
import Website from "../../../Common/website";
import SendEmail from "../../../Common/SendEmail";
import LeadUserDefineFieldsSection from '../../../Lead/Views/LeadForms/LeadUserDefineFieldsSection';
import JobUserDefineService from "../../../Jobs/Controller/UserDefineJobController";
import { handleSubmit as handleUserDefineSubmit } from "../../../Jobs/Controller/CreateUserDefineController";
import IndustrySectorService from "../../../Setup/controller/IndustrySectorController/IndustrySectorController";

import CompanySetupController from "../../../SuperAdmin/Controller/Client/SACompanyListController";
import JasperReportService from '../../../Dashboard/Controller/JasperReportController';
import axiosInstance from '../../../../config/axiosInstance';
import BASE_URL from "../../../../config/config";
import Draggable from 'react-draggable';
import ReportService from "../../../Setup/controller/ReportController/ReportController";
import TermsConditionService from "../../../Setup/controller/TermsConditionController/TermsConditionController";
import { PDFDocument } from "pdf-lib";
import { getMergedPDFBlob } from '../../../Common/ReportPDFService';
import CustomerSiteService from "../../../Customer/Controller/CustomerSiteController";
function CustomerDetail({ OpportunityID, onSuccess, Tab, onNext, onPrevious, isLock, onClose, IsCustomerSelection }) {
    const tableRef = useRef();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const getCurrentDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };
    const [formData, setFormData] = useState({
        ID: "0",
        CustomerID: 0,
        CustomerName: '',
        FK_LeadOpportunitySource_Id: "0",
        FK_LeadOpportunityStatus_ID: '0',
        FK_TaxCode_Id: '0',
        FK_Currency_Id: '0',
        FK_Owner_Id: '0',
        FK_Team_Id: '0',
        vc_Company: '',
        vc_Title: 'Mr',
        vc_FirstName: '',
        vc_Surname: '',
        vc_Phone: '',
        vc_Mobile: '',
        vc_Email: '',
        vc_Address1: '',
        vc_Address2: '',
        vc_Address3: '',
        vc_City: '',
        vc_County: '',
        vc_Country: '',
        vc_Website: '',
        dec_Weight: '0.00',
        vc_Topic: '',
        FromLead: "0",
        IndustrialSector: '',
        NoOfEmployees: '0',
        vc_Postcode: '',
        JobRoleID: '0',
        OppType: IsCustomerSelection.toString() === "1" ? "2" : "1",
        FK_ClientBranch_Id: "0",
        vc_Category: "",
        LinkedIn: ""

    });
    const [CommunicationList, setCommunicationData] = useState([]);
    const [showCustomerModal, setShowCustomerModal] = useState(false);
    const [OppurtunitySourceList, setOppurtunitySourceList] = useState([]);
    const [OppurtunityStatusList, setOppurtunityStatusList] = useState([]);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [taxCodeList, setTaxCodes] = useState([]);
    const [currencyList, setCurrenyDate] = useState([]);
    const [CountryList, setCountries] = useState([]);
    const [TitleList, setTitles] = useState([]);
    const [jobRoleList, setJobRoles] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentCommunicationHistory, setCurrentCommunicationHistory] = useState(null);
    const [CustomerList, setCustomer] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
    const [Email, setEmail] = useState();
    const [phone, setPhone] = useState();
    const [mobile, setMobile] = useState();
    const [OpportunityType, setOpportunityType] = useState("0");
    const [KeyNameList, setKeyNames] = useState([]);
    const [IndustrySectorList, setIndustrySector] = useState([]);
    const [isChanged, setIsChanged] = useState(false);
    const fetchIndustrySectors = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const industrySectorData = await IndustrySectorService.GetIndustrySector(redirectCallback);
            setIndustrySector(industrySectorData);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const fetchKeyNames = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const KeyNames = await JobUserDefineService.GetJobUserDefine(redirectCallback, OpportunityID, 18);
            setKeyNames(KeyNames || []);

            // Initialize form data with vc_Value if available
            const initialFormData = {};
            KeyNames.forEach(keyItem => {
                if (keyItem.vc_Value) {
                    initialFormData[keyItem.vc_Name] = keyItem.vc_Value;
                }
            });

            // ✅ Merge into existing formData instead of replacing it
            setFormData(prev => ({
                ...prev,
                ...initialFormData
            }));
        } catch (error) {
            console.error('Error fetching Key Names:', error);
        }
    };
    const handleFieldChange = (event, keyItem = null) => {
        const { name, value } = event.target;
        setIsChanged(true);
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };
    const handleIntegerChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*$/.test(value)) {
            setFormData(prevData => ({ ...prevData, [name]: value }));
        }
    };

    const handleDecimalChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*\.?\d*$/.test(value)) {
            setFormData(prevData => ({ ...prevData, [name]: value }));
        }
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData(prevData => ({ ...prevData, [name]: files[0] }));
    };
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    const resetForm = () => {

        setFormData({
            ID: "0",
            CustomerID: 0,
            CustomerName: '',
            FK_LeadOpportunitySource_Id: "0",
            FK_LeadOpportunityStatus_ID: '0',
            FK_TaxCode_Id: '0',
            FK_Currency_Id: '0',
            FK_Owner_Id: '0',
            FK_Team_Id: '0',
            vc_Company: '',
            vc_Title: 'Mr',
            vc_FirstName: '',
            vc_Surname: '',
            vc_Phone: '',
            vc_Mobile: '',
            vc_Email: '',
            vc_Address1: '',
            vc_Address2: '',
            vc_Address3: '',
            vc_City: '',
            vc_County: '',
            vc_Country: '',
            vc_Website: '',
            dec_Weight: '0.00',
            vc_Topic: '',
            IndustrialSector: '',
            NoOfEmployees: '0',
            vc_Postcode: '',
            JobRoleID: '0',
            OppType: IsCustomerSelection.toString() === "1" ? "2" : "1",
            FK_ClientBranch_Id: "0",
            vc_Category: "",
            LinkedIn: ""

        });
    };
    const fetchCustomers = async () => {
        try {

            const redirectCallback = () => navigate('/');
            const listOfCustomers = await CustomerService.GetAllCustomers(redirectCallback);
            setCustomer(listOfCustomers);
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };
    const fetchTitle = async () => {
        try {
            const listOfTitles = await TitleService.GetAllTitle();
            setTitles(listOfTitles);
            if (listOfTitles.length > 0) {
                setFormData(prevFormData => ({
                    ...prevFormData,
                    vc_Title: listOfTitles[0].Title, // Assuming IssuePriorityID is the field name
                }));
            }
        } catch (error) {
            console.error('Error fetching teams:', error);
        }
    };
    const fetchJobRole = async () => {
        try {
            const list = await JobRoleService.GetAllJobRole();
            setJobRoles(list);

        } catch (error) {
            console.error('Error fetching teams:', error);
        }
    };
    useEffect(() => {
        fetchCustomers();
        fetchOppurtunitySource();
        fetchOppurtunityStatus();
        fetchTaxCode();
        fetchCurrency();
        fetchCountries();
        fetchTitle();
        fetchJobRole();
        fetchIndustrySectors();
        if (OpportunityID > 0) {
            // fetchCommunication();
            fetchOpportunityDetail();
            fetchKeyNames();
        } else {
            fetchKeyNames();

        }
    }, [OpportunityID, Tab]);
    const fetchOppurtunitySource = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const list1 = await OppurtunitySourceService.GetAllOppurtunitySource(redirectCallback);
            setOppurtunitySourceList(list1);
            /*  if (list1.length > 0) {
                  setFormData(prevFormData => ({
                      ...prevFormData,
                      FK_LeadOpportunitySource_Id: list1[0].ID.toString() // Assuming IssuePriorityID is the field name
                  }));
              }*/
        } catch (error) {
            console.error('Error fetching asset categories:', error);
        }
    };

    const fetchOppurtunityStatus = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const list = await OppurtunityStatusService.GetOpportunityStatus(redirectCallback);
            setOppurtunityStatusList(list);
            debugger;
            if (list > 0 && OpportunityID === 0) {
                setFormData(prevFormData => ({
                    ...prevFormData,
                    FK_LeadOpportunityStatus_ID: list[0].ID.toString() // Assuming IssuePriorityID is the field name
                }));
            }
        } catch (error) {
            console.error('Error fetching asset subcategories:', error);
        }
    };
    const fetchTaxCode = async () => {
        try {
            const listOfTaxCodes = await TaxService.GetAllTaxCodes();
            setTaxCodes(listOfTaxCodes);
            if (listOfTaxCodes.length > 0 && OpportunityID < 1) {
                const defaultTax = listOfTaxCodes.find(t => t.IsDefault === 1);
                debugger;
                setFormData(prevFormData => ({
                    ...prevFormData,
                    FK_TaxCode_Id: defaultTax ? defaultTax.ID : listOfTaxCodes[0].ID,  // Assuming IssuePriorityID is the field name
                }));
            }

        } catch (error) {
            console.error('Error fetching tax codes:', error);
        }
    };


    const fetchCommunication = async () => {
        try {
            setCommunicationData([]);
            setLoading(true);
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const data = await CommunicationService.GetOppurtunityCommunication(redirectCallback, OpportunityID);
            const formatDate = (dateString) => {
                if (!dateString) return null;
                const date = new Date(dateString);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
                const year = date.getFullYear();
                return `${year}/${month}/${day}`;
            };

            const selectedPartsData = data.map(detail => {
                const formattedDate = detail.dt_Created ? detail.dt_Created.slice(0, 10) : '';
                const AppointmentDate = detail.AppointmentDate ? detail.AppointmentDate.slice(0, 10) : '';
                const DueDate = detail.DueDate ? detail.DueDate.slice(0, 10) : '';
                const AppointmentEndDate = detail.AppointmentEndDate ? detail.AppointmentEndDate.slice(0, 10) : '';

                return {
                    ID: detail.ID,
                    snt_CommunicationType: detail.snt_CommunicationType.toString(),
                    vc_Description: detail.vc_Description,
                    dt_Created: formattedDate,
                    vc_Subject: detail.vc_Subject,
                    vc_From: detail.vc_From,
                    vc_To: detail.vc_To,
                    vc_CC: detail.vc_CC,
                    AppointmentDate: AppointmentDate,
                    StartTime: detail.StartTime,
                    Completed: detail.Completed,
                    DueDate: DueDate,
                    DueTime: detail.DueTime,
                    DisplayName: detail.DisplayName,
                    AppointmentEndDate: AppointmentEndDate,
                    EndTime: detail.EndTime,
                    UserTask: detail.UserTask,
                    AssignUserID: detail.AssignUserID,
                    StatusText: detail.StatusText,
                    Status: detail.Status,
                    EmailStatus: detail.EmailStatus,
                    IsEmailSend: detail.IsEmailSend,
                };
                // Map other fields as needed
            });

            setCommunicationData(selectedPartsData);
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        } finally {
            setLoading(false); // Stop loading after fetching
        }
    };
    const fetchCurrency = async () => {
        try {

            const listOfCurrencies = await CurrencyService.GetAllCurrencies();
            setCurrenyDate(listOfCurrencies);
            const selectedCustomer = listOfCurrencies.find(currency => currency.bit_BaseCurrency === 1);
            if (selectedCustomer) {
                setFormData(prevFormData => ({
                    ...prevFormData,
                    FK_Currency_Id: selectedCustomer.PK_Currency_ID, // Assuming IssuePriorityID is the field name
                }));
            }
        } catch (error) {
            console.error('Error fetching currencies:', error);
        }
    };
    const fetchOpportunityDetail = async () => {
        try {

            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            setIsChanged(false);
            const LeadDetail = await OppurtunityService.GetOppurtunityByID(redirectCallback, OpportunityID);
            const lead = LeadDetail[0];
            setPhone(LeadDetail[0].vc_Phone);
            setMobile(LeadDetail[0].vc_Mobile);
            setEmail(LeadDetail[0].vc_Email);
            setOpportunityType(LeadDetail[0].OpportunityType)
            setFormData(LeadDetail[0]);
            debugger;
            if (LeadDetail[0].OpportunityType.toString() === "1") {
                await fetchCustomersSites(LeadDetail[0].CustomerID, LeadDetail[0].FK_ClientBranch_Id);
            }


        } catch (error) {
            console.error('Error fetching asset details:', error);
        }
    };
    const handleFormSubmit = async (event) => {
        event.preventDefault();
        if (OpportunityID > 0 && !isChanged) {
            return;
        }
        const redirectCallback = () => {
            navigate('/');
        };

        const redirectUserList = () => {
            navigate('/OpportunityList?saved=true');
        };
        formData.ID = OpportunityID;
        formData.FromLead = "0";
        if (formData.CustomerID > 0) {
            formData.vc_Company = formData.CustomerName;
        }
        const formDataWithParts = {
            formData: formData,
            tableData: CommunicationList
        };
        debugger;
        // const message="User added successfully";
        const message = await handleSubmit(event, formDataWithParts, setFormData, setErrors, redirectCallback, redirectUserList);
        if (message == "User added successfully") {
            setIsChanged(false);
            onSuccess();
            OpportunityID = localStorage.getItem('OpportunityID');
            if (IsCustomerSelection === 1 || IsCustomerSelection === "1") {
                onClose(OpportunityID);
                return;
            }
            else {
                // redirectUserList();
            }

            await handleUserDefineSubmit({
                JobID: localStorage.getItem('OpportunityID'),
                fields: KeyNameList.map(key => ({
                    PK_KeyName_ID: key.PK_KeyName_ID,
                    value: formData[key.vc_Name] || ''
                }))
            });
            localStorage.setItem('HasRecordUpdated', "1");
            setCommunicationData([]);
            await fetchOpportunityDetail();
            //   await fetchCommunication();
            await fetchKeyNames();
            setShowSuccessMessage(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setShowSuccessMessage(false);
            }, 5000);
            //   redirectUserList();
        }
        else {
            setShowErrorMessage(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setShowErrorMessage(false);
            }, 5000);

        }
    };
    const fetchCountries = async () => {
        try {
            const listOfCountries = await CountryService.GetAllCountries();
            setCountries(listOfCountries);
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };
    const handleWeightButtonClick = (value) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            dec_Weight: value.toFixed(2),
        }));
    };

    const handleEditClick = (data, index) => {
        setCurrentCommunicationHistory(data, index);
        setIsModalOpen(true);
    };
    const handleDeleteClick = async (event, ID) => {
        event.stopPropagation(); // Prevent the row click event

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const redirectCallback = () => {
                        navigate('/'); // Redirect to the login page
                    };
                    await CommunicationService.DeleteCommunication(ID, redirectCallback);
                    //   fetchCommunication();
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });
    };
    const handleAddCommunicationHistory = () => {
        setCurrentCommunicationHistory(null);
        setIsModalOpen(true);
    };
    const handleCloseModal = () => {
        setIsChanged(true);
        setIsModalOpen(false);
        //  fetchCommunication();
    };
    const handleCommunicationSubmit = async (CommunicationData) => {
        debugger;
        if (Array.isArray(CommunicationData)) {
            const existingEntriesMap = new Map(CommunicationList.map(entry => [entry.ID, entry]));
            const updatedEntries = [];
            const newEntries = [];

            CommunicationData.forEach(data => {
                if (data.ID > 0) {
                    // Update existing entry if present
                    if (existingEntriesMap.has(data.ID)) {
                        updatedEntries.push(data);
                    } else {
                        // If an entry has a valid ID but doesn't exist, add it as new
                        newEntries.push(data);
                    }
                } else {
                    // Generate a unique EngineerTimeID for new entries
                    const newID = CommunicationList.length > 0
                        ? Math.max(...CommunicationList.map(row => row.ID)) + 1
                        : 1;
                    data.ID = 0;
                    newEntries.push(data);
                }
            });

            const finalTableData = [
                ...CommunicationList.filter(entry => !updatedEntries.some(updated => updated.ID === entry.ID)),
                ...updatedEntries,
                ...newEntries
            ];
            setCommunicationData(finalTableData);

            setIsModalOpen(false);
        }

    };
    const truncateText = (text, maxLength = 150) => {
        if (!text) return '';  // Return empty string if text is null or empty
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };

    const handleCustomerSelect = async (customer) => {
        debugger;
        setFormData({
            ...formData,
            CustomerID: customer.ClientCompanyID,
            CustomerName: customer.CompanyName,
            vc_Address1: customer.Address1,
            vc_Address2: customer.Address2,
            vc_Address3: customer.Address3,
            vc_City: customer.City,
            vc_County: customer.County,
            vc_Country: customer.Country,
            FK_TaxCode_Id: customer.FK_TaxCode_ID,
            FK_Currency_Id: customer.FK_Currency_ID,



        });
        await fetchCustomersSites(customer.ClientCompanyID, "0");
        setShowCustomerModal(false);
    };
    const handleEmailClick = async (event, email) => {
        event.stopPropagation();
        setEmail(email)
        setIsEmailModalOpen(true);
    };
    const handleCloseEmailModal = async () => {
        setIsEmailModalOpen(false);
        // fetchCommunication();
    };
    const HelpLink = localStorage.getItem('HelpLink');
    const [CustomerSiteList, setCustomerSite] = useState([]);
    const [imageData, setImageData] = useState(null);
    const [reportLink, setReportLink] = useState('');
    const [reportTitle, setReportTitle] = useState('');
    const [error, setError] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null); // State to store the PDF URL
    const [showPdfModal, setShowPdfModal] = useState(false);
    useEffect(() => {
        // Load image as base64
        const loadImage = async () => {
            try {
                const ClientID = localStorage.getItem('CompanyID');
                const redirectCallback = () => {
                    navigate('/'); // Redirect to the login page
                };

                const companySetup = await CompanySetupController.GetCompanyByID(redirectCallback, ClientID);
                const fileName = companySetup[0]?.FileName; // Check if fileName exists

                let imageUrl;
                if (!fileName) {
                    // Use fallback image if fileName is null or empty
                    imageUrl = 'assets/img/resources/trent.PNG';
                } else {
                    imageUrl = `${BASE_URL}/uploads/${ClientID}/Admin/CompanySetup/${fileName}`;
                }
                debugger;
                console.log("Fetching image from:", imageUrl); // Debugging

                const response = await fetch(imageUrl, {
                    method: 'GET',
                    mode: 'cors', // Ensure CORS mode
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    console.error(`Error fetching image: ${response.statusText}`);
                    return;
                }

                const blob = await response.blob();
                const reader = new FileReader();
                reader.onloadend = () => {
                    setImageData(reader.result); // Convert to base64
                };
                reader.readAsDataURL(blob);
            } catch (error) {
                console.error("Error loading image:", error);
            }
        };

        loadImage();
    }, []);
    const generatePDF = async (event) => {
        event.stopPropagation();

        try {
            const blob = await getMergedPDFBlob({
                moduleId: "18",
                navigate,
                currentInputValues: {
                    ID: OpportunityID
                },
                defaultReportID: 113,
                setReportLink,
                setReportTitle,
                setError
            });
            const finalUrl = URL.createObjectURL(blob);
            setPdfUrl(finalUrl);
            setShowPdfModal(true);



        } catch (err) {
            console.error(err);
        }
    };

    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const handleRadioChange = (event) => {
        const { value } = event.target;
        setIsChanged(true);
        // Create a base object with `type` updated
        let updatedFormData = {
            ...formData,
            OppType: value
        };

        // Extend `updatedFormData` with additional fields based on the selected value
        if (value === "1") {
            // setCustomerModal(true);
        } else if (value === "2") {
            // setLeadModal(true);
        } else if (value === "2") {
            // setOpportunityModal(true);
        }

        // Update the formData state with the final object
        setFormData(updatedFormData);
    };
    const fetchCustomersSites = async (customerID, ClientBranchID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            debugger;
            const listOfCustomerSites = await CustomerSiteService.GetAllCustomersSites(redirectCallback, customerID);
            setCustomerSite(listOfCustomerSites);
            if (ClientBranchID > 0) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    FK_ClientBranch_Id: ClientBranchID,
                }));
            }
            else {
                const headOfficeSite = listOfCustomerSites.find(site => site.HeadOffice === 1);
                if (headOfficeSite) {
                    setFormData((prevFormData) => ({
                        ...prevFormData,
                        FK_ClientBranch_Id: headOfficeSite.ClientBranchID,
                    }));

                } else if (listOfCustomerSites.length > 0) {
                    setFormData((prevFormData) => ({
                        ...prevFormData,
                        FK_ClientBranch_Id: headOfficeSite.ClientBranchID,
                    }));

                }
            }
        } catch (error) {
            console.error('Error fetching customer sites:', error);
        }
    };
    return (
        <div>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}
            <form onSubmit={handleFormSubmit} style={{
                display: "flex",
                flexDirection: "column",
                maxHeight: "calc(100vh - 335px)",     // IE/Edge
            }}>
                <div
                    style={{
                        // flex: 1,
                        overflowY: "auto",
                        overflowX: "hidden",
                        // scrollbarWidth: "none", // Firefox
                        // msOverflowStyle: "none", // IE/Edge
                    }}
                    className=""
                >
                    <table style={{ width: "100%" }}>
                        <tbody>
                            {(IsCustomerSelection != "1" &&
                                <tr>
                                    <td style={{ width: "13%" }}>
                                        <label htmlFor="Type" style={{ float: "right" }}></label>
                                    </td>
                                    <td style={{ width: "37%" }}>
                                        {(formData.ID < 1 &&
                                            <table style={{ width: "100%" }}>
                                                <tr>
                                                    <td>
                                                        <table style={{ width: "100%" }}>
                                                            <tr>
                                                                <td>
                                                                    <input style={{ position: "relative" }} type="radio" name="OppType" value="1" checked={formData.OppType == '1'}
                                                                        onChange={handleRadioChange}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <label className="col-form-label">Existing Customer</label>
                                                                </td>

                                                                <td>
                                                                    <input style={{ position: "relative" }} type="radio" name="OppType" value="2" checked={formData.OppType == '2'}
                                                                        onChange={handleRadioChange}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <label className="col-form-label">New Opportunity</label>
                                                                </td>


                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </table>
                                        )}
                                    </td>
                                    <td style={{ width: "13%" }}>

                                    </td>
                                    <td style={{ width: "37%" }}>

                                    </td>

                                </tr>
                            )}
                            <tr>
                                <td style={{ width: "13%" }}>
                                    <label htmlFor="Forename" style={{ float: "right" }}>Title &nbsp;&nbsp;</label>
                                </td>
                                <td style={{ width: "37%" }}>
                                    <table style={{ width: "100%" }}>
                                        <tr>
                                            <td>
                                                <select name="vc_Title" className='form-control' value={formData.vc_Title}
                                                    onChange={handleFieldChange} >
                                                    <option value="0">Select Title</option>
                                                    {TitleList.map((title) => (
                                                        <option key={title.Title} value={title.Title}>
                                                            {title.Title}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.vc_Title && <div style={{ color: 'red' }}>{errors.vc_Title}</div>}
                                            </td>
                                            <td >
                                                <label htmlFor="dec_Weight" style={{ float: "right" }}>Position &nbsp;&nbsp;</label>
                                            </td>
                                            <td>
                                                <select name="JobRoleID" className='form-control' value={formData.JobRoleID} onChange={handleFieldChange}>
                                                    <option value="0">Select Position</option>
                                                    {jobRoleList.map((jobRole) => (
                                                        <option key={jobRole.ID} value={jobRole.ID}>
                                                            {jobRole.JobRole}
                                                        </option>
                                                    ))}
                                                </select>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                                <td>
                                    <label htmlFor="vc_Company" style={{ float: "right" }}>Company <span style={{ "color": "red" }}>*</span></label>
                                </td>
                                <td>
                                    {formData.OppType.toString() == "1" && (
                                        <>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="CustomerID"
                                                name="CustomerID"
                                                value={formData.CustomerName}
                                                onClick={() => setShowCustomerModal(true)}
                                                readOnly
                                                disabled={formData.CustomerID === -10 || formData.CustomerID === "-10"}

                                            />
                                            {errors.CustomerID && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.CustomerID}</div>}
                                        </>
                                    )}

                                    {formData.OppType.toString() == "2" && (
                                        <>
                                            <input type="text" className="form-control" name="vc_Company" value={formData.vc_Company} onChange={handleFieldChange} />
                                            {errors.vc_Company && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.vc_Company}</div>}
                                        </>
                                    )}
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <label htmlFor="vc_FirstName" style={{ float: "right" }}>First Name <span style={{ "color": "red" }}>*</span></label>
                                </td>
                                <td>
                                    <input type="text" className="form-control" name="vc_FirstName" value={formData.vc_FirstName} onChange={handleFieldChange} />
                                    {errors.vc_FirstName && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.vc_FirstName}</div>}

                                </td>
                                {formData.OppType.toString() == "1" && (
                                    <>
                                        <td>

                                            <label htmlFor="vc_SerialNumber" style={{ float: "right" }}>Site Name :<span style={{ "color": "red" }}>*</span></label>
                                        </td>
                                        <td>
                                            <select name="FK_ClientBranch_Id" className='form-control' value={formData.FK_ClientBranch_Id} onChange={handleFieldChange}>
                                                <option value="0">Select Site</option>
                                                {CustomerSiteList.map((site) => (
                                                    <option key={site.ClientBranchID} value={site.ClientBranchID}>
                                                        {site.BranchName}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.FK_ClientBranch_Id && <div style={{ color: 'red' }}>{errors.FK_ClientBranch_Id}</div>}
                                        </td>
                                    </>
                                )}


                            </tr>

                            <tr>
                                <td>
                                    <label htmlFor="vc_Surname" style={{ float: "right" }}>Surname <span style={{ "color": "red" }}>*</span></label>
                                </td>
                                <td>
                                    <input type="text" className="form-control" name="vc_Surname" value={formData.vc_Surname} onChange={handleFieldChange} />
                                    {errors.vc_Surname && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.vc_Surname}</div>}

                                </td>

                                <td>
                                    <label htmlFor="vc_Address1" style={{ float: "right" }}>Address <span style={{ "color": "red" }}>*</span></label>
                                </td>
                                <td>
                                    <input type="text" className="form-control" name="vc_Address1" value={formData.vc_Address1} onChange={handleFieldChange} />
                                    {errors.vc_Address1 && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.vc_Address1}</div>}

                                </td>


                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="vc_Phone" style={{ float: "right" }}>Telephone &nbsp;&nbsp;</label>
                                </td>

                                <td>
                                    <table style={{ width: "100%" }}>
                                        <tr>
                                            <td>
                                                <input type="text" className="form-control" name="vc_Phone" value={formData.vc_Phone} onChange={handleFieldChange} />
                                            </td>

                                            <td>
                                                {(OpportunityID > 0) && (formData.vc_Phone != "" && formData.vc_Phone != null && formData.vc_Phone != "undefined") && (
                                                    <a href={`tel:${formData.vc_Phone}`} onClick={(e) => e.stopPropagation()}>
                                                        <img src="assets/img/resources/phone.jpeg" alt="Add icon" style={{ height: "22px" }} />
                                                    </a>
                                                )}
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                                <td>
                                    <label htmlFor="vc_Address2" style={{ float: "right" }}></label>
                                </td>
                                <td>
                                    <input type="text" className="form-control" name="vc_Address2" value={formData.vc_Address2} onChange={handleFieldChange} />

                                </td>


                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="vc_Mobile" style={{ float: "right" }}>Mobile &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <table style={{ width: "100%" }}>
                                        <tr>
                                            <td>
                                                <input type="text" className="form-control" name="vc_Mobile" value={formData.vc_Mobile} onChange={handleFieldChange} />

                                            </td>
                                            <td>
                                                {(OpportunityID > 0) && (formData.vc_Mobile != "" && formData.vc_Mobile != null && formData.vc_Mobile != "undefined") && (
                                                    <a href={`tel:${formData.vc_Mobile}`} onClick={(e) => e.stopPropagation()}>
                                                        <img src="assets/img/resources/phone.jpeg" alt="Add icon" style={{ height: "22px" }} />
                                                    </a>
                                                )}
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                                <td>
                                    <label htmlFor="vc_Address1" style={{ float: "right" }}></label>
                                </td>
                                <td>
                                    <input type="text" className="form-control" name="vc_Address3" value={formData.vc_Address3} onChange={handleFieldChange} />


                                </td>




                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="vc_Topic" style={{ float: "right" }}>Product/Service <span style={{ "color": "red" }}>*</span></label>
                                </td>
                                <td>
                                    <textarea type="text" rows={2} className="form-control" name="vc_Topic" value={formData.vc_Topic} onChange={handleFieldChange}
                                    />
                                    {errors.vc_Topic && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.vc_Topic}</div>}
                                </td>
                                <td>
                                    <label htmlFor="vc_City" style={{ float: "right" }}>Town or City &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <input type="text" className="form-control" name="vc_City" value={formData.vc_City} onChange={handleFieldChange} />

                                </td>


                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="vc_Email" style={{ float: "right" }}>Email &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <table style={{ width: "100%" }}>
                                        <tr>
                                            <td>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    id="vc_Email"
                                                    name="vc_Email"
                                                    value={formData.vc_Email}
                                                    onChange={handleFieldChange}


                                                    placeholder="Enter email"
                                                />
                                            </td>
                                            <td>
                                                {(OpportunityID > 0) && (formData.vc_Email != "" && formData.vc_Email != null && formData.vc_Email != "undefined") && (

                                                    <a href='#' onClick={(event) => handleEmailClick(event, formData.vc_Email)}>
                                                        <img src="assets/img/resources/email-icon.png" alt="Add icon" style={{ height: "22px" }} />
                                                    </a>
                                                )}

                                            </td>
                                        </tr>
                                    </table>
                                </td>
                                <td>
                                    <label htmlFor="vc_County" style={{ float: "right" }}>County &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <input type="text" className="form-control" name="vc_County" value={formData.vc_County} onChange={handleFieldChange} />

                                </td>



                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="vc_Website" style={{ float: "right" }}>Website &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <table style={{ width: "100%" }}>
                                        <tr>
                                            <td>
                                                <input type="text" className="form-control" name="vc_Website" value={formData.vc_Website} onChange={handleFieldChange} />

                                            </td>
                                            <td>
                                                {(OpportunityID > 0) && (formData.vc_Website != "" && formData.vc_Website != null && formData.vc_Website != "undefined") && (
                                                    <Website webLink={formData.vc_Website} />
                                                )}
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                                <td>
                                    <label htmlFor="vc_Postcode" style={{ float: "right" }}>Post Code &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <input type="text" className="form-control" name="vc_Postcode" value={formData.vc_Postcode} onChange={handleFieldChange} />
                                </td>



                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="dec_Weight" style={{ float: "right" }}>Source &nbsp;&nbsp;<span style={{ "color": "red" }}>*</span></label>
                                </td>
                                <td>
                                    <select name="FK_LeadOpportunitySource_Id" className='form-control' value={formData.FK_LeadOpportunitySource_Id}
                                        onChange={handleFieldChange}>
                                        <option value="0">Select Source</option>
                                        {OppurtunitySourceList.map((opportunity) => (
                                            <option key={opportunity.ID} value={opportunity.ID}>
                                                {opportunity.vc_Name}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.FK_LeadOpportunitySource_Id && <div style={{ color: 'red', "fontSize": "0.8vw" }}>{errors.FK_LeadOpportunitySource_Id}</div>}

                                </td>
                                <td>
                                    <label htmlFor="vc_County" style={{ float: "right" }}>Country &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <select name="vc_Country" className='form-control' value={formData.vc_Country} onChange={handleFieldChange}>
                                        <option value="0">Select Country</option>
                                        {CountryList.map((country) => (
                                            <option key={country.PK_Country_ID} value={country.PK_Country_ID}>
                                                {country.vc_CountryName}
                                            </option>
                                        ))}
                                    </select>

                                </td>


                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="IndustrialSector" style={{ float: "right" }}>Category &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <select name="IndustrialSector" className='form-control' value={formData.IndustrialSector} onChange={handleFieldChange}>
                                        <option value="0">Select Category</option>
                                        {IndustrySectorList.map((industry) => (
                                            <option key={industry.IndustrialSector} value={industry.IndustrialSector}>
                                                {industry.IndustrialSector}
                                            </option>
                                        ))}
                                    </select>

                                </td>
                                <label htmlFor="dec_Weight" style={{ float: "right" }}>Tax Code &nbsp;&nbsp;</label>
                                <td>
                                    <select name="FK_TaxCode_Id" className='form-control' value={formData.FK_TaxCode_Id} onChange={handleFieldChange}>
                                        <option value="0">Select Tax Code</option>
                                        {taxCodeList.map((taxCode) => (
                                            <option key={taxCode.ID} value={taxCode.ID}>
                                                {taxCode.vc_Code} ( {taxCode.dec_Rate} )
                                            </option>
                                        ))}
                                    </select>
                                    {errors.FK_TaxCode_Id && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.FK_TaxCode_Id}</div>}
                                </td>



                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="NoOfEmployees" style={{ float: "right" }}>Employees &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <input type="text" className="form-control" name="NoOfEmployees" value={formData.NoOfEmployees}
                                        onChange={(e) => {
                                            // remove all non-digit characters (in case of paste)
                                            const cleaned = e.target.value.replace(/\D/g, '');
                                            handleChange({ target: { name: 'NoOfEmployees', value: cleaned } }, formData, setFormData);
                                        }}
                                        inputMode="numeric"
                                        autoComplete="off" />
                                    {errors.NoOfEmployees && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.NoOfEmployees}</div>}
                                </td>
                                <td> <label htmlFor="dec_Weight" style={{ float: "right" }}>Base Currency &nbsp;&nbsp;</label></td>
                                <td>
                                    <select name="FK_Currency_Id" className='form-control' value={formData.FK_Currency_Id} onChange={handleFieldChange}>
                                        <option value="0">Select Currency</option>
                                        {currencyList.map((currency) => (
                                            <option key={currency.PK_Currency_ID} value={currency.PK_Currency_ID}>
                                                {currency.vc_CurrencyName}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.FK_Currency_Id && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.FK_Currency_Id}</div>}

                                </td>





                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="FK_LeadOpportunitySource_Id" style={{ float: "right" }}> Status &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <select name="FK_LeadOpportunityStatus_ID" className='form-control' value={formData.FK_LeadOpportunityStatus_ID} onChange={handleFieldChange}>
                                        <option value="0">Select Status</option>
                                        {OppurtunityStatusList.map((opportunity) => (
                                            <option key={opportunity.ID} value={opportunity.ID}>
                                                {opportunity.vc_Name}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.FK_LeadOpportunityStatus_ID && <div style={{ color: 'red', "fontSize": "0.8vw" }}>{errors.FK_LeadOpportunityStatus_ID}</div>}

                                </td>
                                <td>
                                    <label htmlFor="dec_Weight" style={{ float: "right" }}></label>
                                </td>
                                <td>
                                    <button style={{ background: "#9CA3AF" }} type="button" className="btn btn-primary" onClick={() => handleWeightButtonClick(0)}>
                                        0%
                                    </button>
                                    <button style={{ "marginLeft": "5px", background: "#3B82F6" }} type="button" className="btn btn-secondary" onClick={() => handleWeightButtonClick(25)}>
                                        25%
                                    </button>
                                    <button style={{ "marginLeft": "5px", background: "#F59E0B" }} type="button" className="btn btn-success" onClick={() => handleWeightButtonClick(50)}>
                                        50%
                                    </button>
                                    <button style={{ "marginLeft": "5px", background: "#16A34A" }} type="button" className="btn btn-dark" onClick={() => handleWeightButtonClick(100)}>
                                        100%
                                    </button>




                                </td>



                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="IndustrySector" style={{ float: "right" }}>Industry &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <input type="text" className="form-control" name="vc_Category" value={formData.vc_Category} onChange={handleFieldChange} />
                                    {errors.vc_Category && <div style={{ "color": "red", "fontSize": "0.8vw" }}>{errors.vc_Category}</div>}
                                </td>
                                <td> <label htmlFor="FK_TaxCode_Id" style={{ float: "right" }}>Weighting &nbsp;&nbsp;</label></td>
                                <td>

                                    <input type="text" className="form-control" name="dec_Weight" value={formData.dec_Weight} onChange={handleFieldChange} />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label htmlFor="IndustrySector" style={{ float: "right" }}>LinkedIn Address &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <table style={{ width: "100%" }}>
                                        <tr>
                                            <td>
                                                <input type="text" className="form-control" name="LinkedIn" value={formData.LinkedIn} onChange={handleFieldChange} />
                                            </td>
                                            <td>
                                                {(OpportunityID > 0) && (formData.LinkedIn != "" && formData.LinkedIn != null && formData.LinkedIn != "undefined") && (
                                                    <Website webLink={formData.LinkedIn} />
                                                )}
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>


                            {KeyNameList.length > 0 && (
                                <>
                                    <LeadUserDefineFieldsSection
                                        KeyNameList={KeyNameList}
                                        formData={formData}
                                        errors={errors}
                                        handleInputChange={handleFieldChange}
                                        handleDecimalChange={handleDecimalChange}
                                        handleIntegerChange={handleIntegerChange}
                                        handleFileChange={handleFileChange}
                                    />
                                </>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                    <div className="col-sm-6">
                        <button type="button" style={{ background: "#2E7D32" }} className={`btn btn-secondary btn-sm ${parseInt(isLock) > 0 ? 'disabled' : ''}`} disabled={parseInt(isLock) > 0} onClick={handleAddCommunicationHistory}>
                            <i className="icofont-plus" aria-hidden="true"></i>Add Comms
                        </button>

                    </div>
                    <div className="col-sm-6">
                        <button onClick={() => onClose(isChanged)} type="button" className={`btn btn-danger`} style={{ float: "right", "marginLeft": "5px" }}>
                            <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                        </button>
                        <button type="submit" className={`btn btn-primary ${parseInt(isLock) > 0 ? 'disabled' : ''}`} disabled={parseInt(isLock) > 0 || localStorage.getItem('LicenseExpired') == "1"} style={{ float: "right", "marginLeft": "5px" }}>
                            <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />
                            {OpportunityID > 0 ? ' Update' : ' Save'}

                        </button>
                        <button style={{ "marginLeft": "5px", float: "right" }} type="button" className="btn btn-secondary" onClick={generatePDF}>
                            <img src="assets/img/resources/printer-icon.png" alt="Add icon" style={{ height: "10px" }} />  Print
                        </button>
                        <button type='button' className="btn btn-previous" style={{ float: "right", "marginLeft": "5px" }} onClick={() => onNext(isChanged)}>
                            <img src="assets/img/resources/next-icon.png" alt="Add icon" style={{ height: "10px" }} />  Next
                        </button>
                        <button type='button' className="btn btn-previous" style={{ float: "right" }} onClick={() => onPrevious(isChanged)}>
                            <img src="assets/img/resources/pevious-icon.png" alt="Add icon" style={{ height: "10px" }} />  Previous
                        </button>

                    </div>
                </div>

            </form>

            {showPdfModal && pdfUrl && (
                <div className="modal fade show d-block" tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-content" onStart={handleStart}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">PDF Report</h5>
                                    <button type="button" className="close" onClick={() => setShowPdfModal(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <embed src={pdfUrl} type="application/pdf" width="100%" height="600px" />
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            )}

            {isModalOpen && (
                <CreateOppCommunicationModal
                    show={isModalOpen}
                    currentCommunicationHistory={currentCommunicationHistory}
                    onFormSubmit={handleCommunicationSubmit}
                    onClose={handleCloseModal}
                    data={formData}
                    OpportunityID={OpportunityID}
                    Phone={phone}
                    Mobile={mobile}
                    ToEmail={Email}
                />
            )}
            {showCustomerModal === true && (
                <CustomerSelectionModal
                    show={showCustomerModal}
                    onClose={() => setShowCustomerModal(false)}
                    customers={CustomerList}
                    onSelectCustomer={handleCustomerSelect}
                />
            )}
            {isEmailModalOpen && (
                <SendEmail onClose={handleCloseEmailModal} ToEmail={Email} Module="Opportunity" ModuleID={OpportunityID} />
            )}
        </div>


    );
}
export default CustomerDetail;

